import { Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  STATUS_LABEL_TEXT,
  STATUS_LABEL_ICONS,
  StatusLabelSize,
  Status,
} from '../../models/status-label.model';

@Component({
  selector: 'app-status-label',
  imports: [FontAwesomeModule],
  templateUrl: './status-label.component.html',
  styleUrl: './status-label.component.scss',
})
export class StatusLabelComponent {
  readonly status = input.required<Status>();

  readonly size = input<StatusLabelSize>('large');

  readonly label = computed(() => STATUS_LABEL_TEXT[this.status()]);

  readonly icon = computed(() => STATUS_LABEL_ICONS[this.status()]);

  readonly STATUSES = Status;
}
